/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Historical: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.00024 0C3.58024 0 0.000244141 3.58 0.000244141 8C0.000244141 12.42 3.58024 16 8.00024 16C12.4197 16 16.0002 12.42 16.0002 8C16.0002 3.58 12.4197 0 8.00024 0ZM8.00024 14C4.68974 14 2.00024 11.31 2.00024 8C2.00024 7.725 2.22524 7.5 2.50024 7.5C2.77474 7.5 3.00024 7.725 3.00024 8C3.00024 10.755 5.24524 13 8.00024 13C10.7547 13 13.0002 10.755 13.0002 8C13.0002 5.245 10.7547 3 8.00024 3C6.66024 3 5.41024 3.52 4.46474 4.465L5.50024 5.5L2.50024 6L3.00024 3L3.75974 3.76C4.89024 2.625 6.39974 2 8.00024 2C11.3102 2 14.0002 4.69 14.0002 8C14.0002 11.31 11.3102 14 8.00024 14ZM8.86524 7.5H10.5002C10.7747 7.5 11.0002 7.725 11.0002 8C11.0002 8.275 10.7747 8.5 10.5002 8.5H8.86524C8.68974 8.8 8.37024 9 8.00024 9C7.45024 9 7.00024 8.55 7.00024 8C7.00024 7.63 7.20024 7.31 7.50024 7.135V5C7.50024 4.725 7.72524 4.5 8.00024 4.5C8.27474 4.5 8.50024 4.725 8.50024 5V7.135C8.64974 7.225 8.77474 7.35 8.86524 7.5Z'
				fill='#F59F00'
			/>
		</Svg>
	);
};

export { Historical };
